import { RefreshCcw, Network, FileBarChart } from "lucide-react";
import { FadeUp, SlideTitle, SlideConclusion } from "../Deck";

const CARDS = [
  {
    icon: RefreshCcw,
    h: "Continuity",
    p: "Patients move from ward to managed rehabilitation at home.",
  },
  {
    icon: Network,
    h: "A network, not headcount",
    p: "Credentialed physiotherapists without new staff.",
  },
  {
    icon: FileBarChart,
    h: "Outcomes returned",
    p: "Recovery data goes back to the treating department.",
  },
];

const BG_IMG =
  "https://images.unsplash.com/photo-1645005513751-e22717a66ae6?q=85&w=1920&auto=format&fit=crop";

export default function Slide08Hospitals() {
  return (
    <div className="relative">
      <div className="absolute inset-0" aria-hidden="true">
        <img src={BG_IMG} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-mint via-mint/85 to-mint/20" />
        <div className="absolute inset-0 bg-gradient-to-t from-mint via-transparent to-mint/60" />
      </div>
      <div className="relative z-10">
        <SlideTitle className="max-w-3xl">
          Care that continues{" "}
          <em className="italic text-gold">after discharge</em>
        </SlideTitle>
        <div className="mt-12 grid gap-6 md:grid-cols-3">
          {CARDS.map((c, i) => (
            <FadeUp
              key={c.h}
              delay={0.1 + i * 0.1}
              className="h-full rounded-3xl border border-line bg-white/95 p-8 backdrop-blur-sm"
            >
              <div className="flex h-11 w-11 items-center justify-center rounded-full bg-mint text-navy">
                <c.icon size={20} strokeWidth={1.8} />
              </div>
              <h3 className="mt-6 text-xl font-semibold tracking-tight">
                {c.h}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-mut">{c.p}</p>
            </FadeUp>
          ))}
        </div>
        <SlideConclusion>
          Extend rehabilitation beyond your walls.
        </SlideConclusion>
      </div>
    </div>
  );
}
